export default "__VITE_ASSET__QnsfbFD1__"